import { useCustomerContext } from '../contexts/CustomerContext';

export function useCustomers() {
  const context = useCustomerContext();
  
  if (!context) {
    throw new Error('useCustomers must be used within a CustomerProvider');
  }
  
  return context;
}

export default useCustomers;